export enum Tenants {
  OtoStolik = 'otostolik',
  LUBJE = 'lubje',
  LesznoJe = 'lesznoje',
  OstrowJe = 'ostrowje',
  MiedzioweJe = 'miedzioweje',
}
